import './homecbam.less'

import {m, wrap} from '@codeurs/front'
import {BlocksData, CardData, LinkType, PageData, PaginationResult} from 'types'
import {ArticleCard, ArticleGrid} from 'views/partials/articlegrid'

import {RssIcon} from 'assets/inline-icons'
import {useList} from 'hooks/uselist'
import {Component} from 'react'
import {style} from 'util/style'
import {Layout} from 'views/layout'
import {HeaderPortal} from 'views/partials/header'
import {Hero} from 'views/partials/hero'
import {LoadMore} from 'views/partials/loadmore'
import {Theme} from 'views/theme'
import {Blocks} from '../blocks/blocks'

const styles = style('homecbam', ['news'])

@wrap(Layout)
export class HomeCbam extends Component<{
  data: PageData &
    BlocksData & {
      page_title: string
      news_title: string
      news_rssfeed: LinkType
      news_overview: LinkType
      articles: PaginationResult<CardData>
      featured_articles: Array<CardData & {half_page: boolean}>
    }
}> {
  getListStartAmount() {
    const {featured_articles} = this.props.data
    let amount = 12
    featured_articles.forEach(fa => {
      amount--
      if (fa.half_page) amount--
    })
    return amount
  }

  render() {
    const {
      id,
      url,
      page_title,
      blocks,
      news_title,
      news_rssfeed,
      news_overview,
      tagslist,
      tagspath,
      articles,
      featured_articles,
      title
    } = this.props.data

    const list = useList<CardData>({
      url,
      data: {json: 'articles'},
      hydrate: articles,
      amounts: {
        start: this.getListStartAmount(),
        page: 12
      }
    })

    const pageTitle = page_title || title

    return (
      <div class={styles}>
        <Theme.Container class={styles('container')}>
          <HeaderPortal>
            <Hero hero={true}>
              {pageTitle && <Theme.H1>{pageTitle}</Theme.H1>}
            </Hero>
          </HeaderPortal>
        </Theme.Container>
        {blocks && blocks.length > 0 && (
          <div class={styles('blocks')}>
            <Theme.Container>
              <Blocks blocks={blocks} pageId={id} wide={true} />
            </Theme.Container>
          </div>
        )}
        <div class={styles.news()}>
          {(news_title || news_rssfeed?.url || news_overview?.url) && (
            <Theme.Container>
              <div class={styles.news('row')}>
                {news_title && <Theme.H2>{news_title}</Theme.H2>}
                {news_rssfeed?.url && (
                  <Theme.Link
                    to={news_rssfeed?.url}
                    class={styles.news('row-rss')}
                  >
                    <span class={styles.news('row-rss-icon')}>
                      <RssIcon />
                    </span>
                    <span class={styles.news('row-rss-label')}>
                      {news_rssfeed?.description || news_rssfeed?.title}
                    </span>
                  </Theme.Link>
                )}
                {news_overview?.url && (
                  <div class={styles.news('row-right')}>
                    <Theme.Link to={news_overview?.url}>
                      {news_overview?.description || news_overview?.title}
                    </Theme.Link>
                  </div>
                )}
              </div>
            </Theme.Container>
          )}
          <ArticleGrid hasMore={list.hasMore} mod="homecbam">
            {featured_articles.map((item, i) => (
              <ArticleCard
                item={{key: i, ...item, category: undefined}}
                tagspath={tagspath}
                tagslist={tagslist}
                half={item.half_page}
              />
            ))}
            {list.items.map((item, i) => (
              <ArticleCard
                item={{key: i, ...item, category: undefined}}
                tagspath={tagspath}
                tagslist={tagslist}
              />
            ))}
          </ArticleGrid>
          {list.hasMore && (
            <div className={styles('button')}>
              <LoadMore
                loading={list.loading}
                loadMore={() => list.loadMore()}
              />
            </div>
          )}
        </div>
      </div>
    )
  }
}
